export enum SportTypes {
    Combat = "Combat",
    Timing = "Timing",
    Scoring = "Scoring",
    Racquet = "Racquet",
    Team = "Team",
    None = "None"
}

export enum SportCodes {
    AIKIDO = "aik",
    ALPINE = "alp",
    ARMWRESTLING = "arm",
    ARTISTIC_SWIMMING = "swa",
    ATHLETICS = "ath",
    BADMINTON = "bdm",
    BASKETBALL = "bkb",
    BASKETBALL_3X3 = "bk3",
    BEACH_VOLLEYBALL = "vbv",
    BOBSLEIGH = "bob",
    BOBSLEIGH_SKELETON = "bsn",
    BOWLS = "lbo",
    BOXING = "box",
    CANOE_FLATWATER = "csp",
    CRICKET = "ckt",
    CROSS_COUNTRY = "ccs",
    CYCLING_MOUNTAIN_BIKE = "mtb",
    CYCLING_ROAD = "crd",
    CYCLING_TRACK = "ctr",
    DIVING = "div",
    FENCING = "fen",
    FIGURE_SKATING = "fsk",
    GOLF = "glf",
    GLOBAL = "glo",
    GYMNASTICS_ARTISTIC = "gar",
    GYMNASTICS_RHYTHMIC = "gry",
    HANDBALL = "hbl",
    HOCKEY = "hoc",
    JUDO = "jud",
    JUJITSU = "jji",
    KARATE = "kte",
    KENDO = "kdo",
    KICKBOXING = "kik",
    LIVE_SAVING = "lfc",
    LUGE = "lug",
    MARATHON_SWIMMING = "ows",
    MUAYTHAI = "mti",
    NETBALL = "nbl",
    NORDIC_COMBINED = "ncb",
    POWERLIFTING = "pwl",
    ROLLER_SKATING_SPEED = "rol",
    RACING = "rac",
    ROWING = "row",
    RUGBY = "rug",
    SAMBO = "sbo",
    SAVATE = "sav",
    SHOOTING = "sho",
    SHORT_TRACK = "stk",
    SKELETON = "skn",
    SKI_JUMPING = "sjp",
    SQUASH = "squ",
    SUMO = "sum",
    SWIMMING = "swm",
    TABLE_TENNIS = "tte",
    TAEKWONDO = "tkw",
    TRIATHLON = "tri",
    WATERPOLO = "wpo",
    WEIGHTLIFTING = "wlf",
    WRESTLING = "wre",
    WUSHU = "wsu"
}

export const SPORTS = {
    AIKIDO: { name: "Aikido", sportCode: SportCodes.AIKIDO, sportType: SportTypes.Combat },
    ALPINE: { name: "Alpine Skiing", sportCode: SportCodes.ALPINE, sportType: SportTypes.Timing },
    ARMWRESTLING: { name: "Armwrestling", sportCode: SportCodes.ARMWRESTLING, sportType: SportTypes.Combat },
    ARTISTIC_SWIMMING: {
        name: "Artistic Swimming",
        sportCode: SportCodes.ARTISTIC_SWIMMING,
        sportType: SportTypes.Scoring
    },
    ATHLETICS: { name: "Athletics", sportCode: SportCodes.ATHLETICS, sportType: SportTypes.Timing },
    BADMINTON: { name: "Badminton", sportCode: SportCodes.BADMINTON, sportType: SportTypes.Racquet },
    BASKETBALL: { name: "Basketball", sportCode: SportCodes.BASKETBALL, sportType: SportTypes.Team },
    BASKETBALL_3X3: { name: "Basketball 3x3", sportCode: SportCodes.BASKETBALL_3X3, sportType: SportTypes.Team },
    BEACH_VOLLEYBALL: { name: "Beach Volleyball", sportCode: SportCodes.BEACH_VOLLEYBALL, sportType: SportTypes.Team },
    BOBSLEIGH: { name: "Bobsleigh", sportCode: SportCodes.BOBSLEIGH, sportType: SportTypes.Timing },
    BOBSLEIGH_SKELETON: {
        name: "Bobsleigh/Skeleton",
        sportCode: SportCodes.BOBSLEIGH_SKELETON,
        sportType: SportTypes.Timing
    },
    BOXING: { name: "Boxing", sportCode: SportCodes.BOXING, sportType: SportTypes.Combat },
    CANOE_FLATWATER: { name: "Canoe Flatwater", sportCode: SportCodes.CANOE_FLATWATER, sportType: SportTypes.Timing },
    CRICKET: { name: "Cricket T20", sportCode: SportCodes.CRICKET, sportType: SportTypes.Team },
    CROSS_COUNTRY: { name: "Cross Country", sportCode: SportCodes.CROSS_COUNTRY, sportType: SportTypes.Timing },
    CYCLING_MOUNTAIN_BIKE: {
        name: "Cycling Mountain Bike",
        sportCode: SportCodes.CYCLING_MOUNTAIN_BIKE,
        sportType: SportTypes.Timing
    },
    CYCLING_ROAD: { name: "Cycling Road", sportCode: SportCodes.CYCLING_ROAD, sportType: SportTypes.Timing },
    CYCLING_TRACK: { name: "Cycling Track", sportCode: SportCodes.CYCLING_TRACK, sportType: SportTypes.Timing },
    DIVING: { name: "Diving", sportCode: SportCodes.DIVING, sportType: SportTypes.Scoring },
    FENCING: { name: "Fencing", sportCode: SportCodes.FENCING, sportType: SportTypes.Combat },
    FIGURE_SKATING: { name: "Figure Skating", sportCode: SportCodes.FIGURE_SKATING, sportType: SportTypes.Scoring },
    GOLF: { name: "Golf", sportCode: SportCodes.GOLF, sportType: SportTypes.Scoring },
    GYMNASTICS_ARTISTIC: {
        name: "Gymnastics Artistic",
        sportCode: SportCodes.GYMNASTICS_ARTISTIC,
        sportType: SportTypes.Timing
    },
    GYMNASTICS_RHYTHMIC: {
        name: "Gymnastics Rhythmic",
        sportCode: SportCodes.GYMNASTICS_RHYTHMIC,
        sportType: SportTypes.Timing
    },
    HANDBALL: { name: "Handball", sportCode: SportCodes.HANDBALL, sportType: SportTypes.Team },
    HOCKEY: { name: "Hockey", sportCode: SportCodes.HOCKEY, sportType: SportTypes.Team },
    JUDO: { name: "Judo", sportCode: SportCodes.JUDO, sportType: SportTypes.Combat },
    JUJITSU: { name: "Ju-Jitsu", sportCode: SportCodes.JUJITSU, sportType: SportTypes.Combat },
    KARATE: { name: "Karate", sportCode: SportCodes.KARATE, sportType: SportTypes.Combat },
    KENDO: { name: "Kendo", sportCode: SportCodes.KENDO, sportType: SportTypes.Combat },
    KICKBOXING: { name: "Kickboxing", sportCode: SportCodes.KICKBOXING, sportType: SportTypes.Combat },
    BOWLS: { name: "Bowls", sportCode: SportCodes.BOWLS, sportType: SportTypes.Team },
    LIVE_SAVING: { name: "Live Saving", sportCode: SportCodes.LIVE_SAVING, sportType: SportTypes.Timing },
    LUGE: { name: "Luge", sportCode: SportCodes.LUGE, sportType: SportTypes.Timing },
    MARATHON_SWIMMING: {
        name: "Marathon Swimming",
        sportCode: SportCodes.MARATHON_SWIMMING,
        sportType: SportTypes.Timing
    },
    MUAYTHAI: { name: "Muaythai", sportCode: SportCodes.MUAYTHAI, sportType: SportTypes.Combat },
    NETBALL: { name: "Netball", sportCode: SportCodes.NETBALL, sportType: SportTypes.Team },
    NORDIC_COMBINED: { name: "Nordic Combined", sportCode: SportCodes.NORDIC_COMBINED, sportType: SportTypes.Timing },
    POWERLIFTING: { name: "Powerlifting", sportCode: SportCodes.POWERLIFTING, sportType: SportTypes.Scoring },
    RACING: { name: "Racing", sportCode: SportCodes.RACING, sportType: SportTypes.Timing },
    ROLLER_SKATING_SPEED: {
        name: "Roller Skating Speed",
        sportCode: SportCodes.ROLLER_SKATING_SPEED,
        sportType: SportTypes.Timing
    },
    ROWING: { name: "Rowing", sportCode: SportCodes.ROWING, sportType: SportTypes.Timing },
    RUGBY: { name: "Rugby Sevens", sportCode: SportCodes.RUGBY, sportType: SportTypes.Team },
    SAMBO: { name: "Sambo", sportCode: SportCodes.SAMBO, sportType: SportTypes.Combat },
    SAVATE: { name: "Savate", sportCode: SportCodes.SAVATE, sportType: SportTypes.Combat },
    SHOOTING: { name: "Shooting", sportCode: SportCodes.SHOOTING, sportType: SportTypes.Scoring },
    SHORT_TRACK: { name: "Short Track", sportCode: SportCodes.SHORT_TRACK, sportType: SportTypes.Timing },
    SKELETON: { name: "Skeleton", sportCode: SportCodes.SKELETON, sportType: SportTypes.Timing },
    SKI_JUMPING: { name: "Ski Jumping", sportCode: SportCodes.SKI_JUMPING, sportType: SportTypes.Scoring },
    SQUASH: { name: "Squash", sportCode: SportCodes.SQUASH, sportType: SportTypes.Racquet },
    SUMO: { name: "Sumo", sportCode: SportCodes.SUMO, sportType: SportTypes.Combat },
    SWIMMING: { name: "Swimming", sportCode: SportCodes.SWIMMING, sportType: SportTypes.Timing },
    TABLE_TENNIS: { name: "Table Tennis", sportCode: SportCodes.TABLE_TENNIS, sportType: SportTypes.Racquet },
    TAEKWONDO: { name: "Taekwondo", sportCode: SportCodes.TAEKWONDO, sportType: SportTypes.Combat },
    TRIATHLON: { name: "Triathlon", sportCode: SportCodes.TRIATHLON, sportType: SportTypes.Timing },
    WATERPOLO: { name: "Waterpolo", sportCode: SportCodes.WATERPOLO, sportType: SportTypes.Team },
    WEIGHTLIFTING: { name: "Weightlifting", sportCode: SportCodes.WEIGHTLIFTING, sportType: SportTypes.Scoring },
    WRESTLING: { name: "Wrestling", sportCode: SportCodes.WRESTLING, sportType: SportTypes.Combat },
    WUSHU: { name: "Wushu", sportCode: SportCodes.WUSHU, sportType: SportTypes.Combat }
};
